import { render, staticRenderFns } from "./MateriaisForm.vue?vue&type=template&id=cc6d72c0&scoped=true"
import script from "./MateriaisForm.vue?vue&type=script&lang=js"
export * from "./MateriaisForm.vue?vue&type=script&lang=js"
import style0 from "./MateriaisForm.vue?vue&type=style&index=0&id=cc6d72c0&prod&lang=css"
import style1 from "./MateriaisForm.vue?vue&type=style&index=1&id=cc6d72c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6d72c0",
  null
  
)

export default component.exports